import { NgModule } from '@angular/core';

import { AnalyticsConstants, analyticsConstantsToken } from './lib/constants';

@NgModule({
  imports: [],
  providers: [
    { provide: analyticsConstantsToken, useValue: AnalyticsConstants },
  ],
})
export class RsAnalyticsConstantsModule {}
